import * as React from "react";
import clsx from "clsx";
import * as s from "./TabSwitcher.style.css";
import type { TabSwitcherProps } from "./TabSwitcher.types";

export type { TabSwitcherProps, TabItem } from "./TabSwitcher.types";

export const TabSwitcher = ({
  tabs,
  value,
  onChange,
  "aria-label": ariaLabel,
  iconsOnly = false,
}: TabSwitcherProps) => {
  return (
    <div className={s.container} role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={tab.value === value}
          aria-label={iconsOnly ? tab.label : undefined}
          title={iconsOnly ? tab.label : undefined}
          className={clsx(
            s.tab,
            tab.value === value && s.tabActive,
            iconsOnly && s.tabIconsOnly,
          )}
          onClick={() => onChange(tab.value)}
        >
          {tab.icon}
          {iconsOnly ? (
            <span className={s.tabLabelHidden}>{tab.label}</span>
          ) : (
            tab.label
          )}
        </button>
      ))}
    </div>
  );
};
